import React from "react";
import { ApplicationIncomeEntry } from "../../types";

interface Props {
  entries: ApplicationIncomeEntry[];
}

export const IncomeSummary: React.FC<Props> = ({ entries }) => {
  if (!entries.length) return null;

  const latest = entries.find((e) => e.current) || entries[0];

  return (
    <p>
      <strong>{latest.jobTitle}</strong>, {latest.company}
    </p>
  );
};
